import { Link } from '@tanstack/react-router';
import { Flex, Typography } from 'antd';

import { styles } from '../../shared';

const FooterLinks = ({
  links,
  title,
}: {
  links: ReadonlyArray<{ label: string; path: string }>;
  title: string;
}) => (
  <Flex className={styles.links} gap={8} vertical>
    <Typography.Text strong>{title}</Typography.Text>
    {links.map((link) => (
      <Link className={styles.link} key={link.path} to={link.path}>
        {link.label}
      </Link>
    ))}
  </Flex>
);

export default FooterLinks;
